// extracted by mini-css-extract-plugin
export default {"home":"index_home__Mgtbt","content":"index_content__f-xhU","top":"index_top__qp+4O","table":"index_table__x940h"};